import React from "react";
import MSkeleton from "@/components/ui/atoms/MSkeleton";

/**
 * Placeholder shown while the documents landing page's first batch of
 * fetches (all documents, type counts, processing summary) are still in
 * flight — avoids the filter chips / upload-history card / records grid
 * popping in one after another as each of their own fetches resolve.
 */
const DocumentsLandingSkeleton: React.FC = () => {
  return (
    <div className="flex w-full flex-col items-center gap-6 px-4 py-6">
      {/* Filter chips row (Favourites / Offline / Private) */}
      <div className="flex w-full items-center gap-3">
        {[0, 1, 2].map((i) => (
          <MSkeleton key={i} className="h-9 flex-1 rounded-full" />
        ))}
      </div>

      {/* Upload history card */}
      <MSkeleton className="h-16 w-full rounded-2xl" />

      {/* Records section header */}
      <div className="flex w-full items-center justify-between">
        <MSkeleton className="h-5 w-32 rounded-full" />
        <MSkeleton className="h-4 w-14 rounded-full" />
      </div>

      {/* Records category grid */}
      <div className="grid w-full grid-cols-2 gap-4">
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <MSkeleton key={i} className="h-24 w-full rounded-2xl" />
        ))}
      </div>

      {/* Health memories row */}
      <MSkeleton className="h-20 w-full rounded-2xl" />
    </div>
  );
};

export default DocumentsLandingSkeleton;
